const ACCENT = "#8a7551";

const Testimonials = () => {
  return (
    <section className="py-28 px-6 md:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="md:w-1/2">
          <div
            className="text-5xl md:text-6xl leading-none mb-2"
            style={{ fontFamily: "var(--font-display)", color: ACCENT }}
            aria-hidden
          >
            “
          </div>

          <blockquote
            className="text-2xl md:text-3xl leading-[1.35] tracking-tight text-foreground"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Bigdelta helps us to keep the entire team aligned around growth. Having{" "}
            <em style={{ color: ACCENT }}>clear and trusted numbers</em> makes decision-making much
            easier.
          </blockquote>

          <figcaption className="flex items-center gap-4 mt-20">
            <img
              src="https://www.warmy.io/images/logo/logo.svg"
              alt="Warmy.io logo"
              className="w-11 h-11 object-contain"
            />
            <div className="leading-tight">
              <p
                className="text-foreground text-base"
                style={{ fontFamily: "var(--font-display)" }}
              >
                Daniel Shnaider
              </p>
              <p className="text-muted-foreground text-sm mt-1">CEO · Warmy.io</p>
            </div>
          </figcaption>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
